  // after scroll
  window.addEventListener('scroll', function () {
    if (window.scrollY > 0) {
      document.querySelector('body').classList.add('scrolled');
    } else {
      document.querySelector('body').classList.remove('scrolled');
    }
  });

  window.dispatchEvent(new Event('scroll'));


  // nav-bottom toggle on mobile
  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-nav-bottom-toggle')) {
      if (mq[0].matches) {
        const toggleBtn = e.target.closest('.js-nav-bottom-toggle');
        toggleBtn.classList.toggle('active');

        const parent = toggleBtn.parentElement;
        if (parent) {
          const sibling = parent.querySelector('.js-nav-bottom');
          if (sibling) {
            sibling.classList.toggle('open');
          }
        }

        e.preventDefault();
      }
    }
  });